// extracted by mini-css-extract-plugin
export default {"thirdPartyBtnWrapper":"f8-z"};